module.exports = __webpack_public_path__ + "img/nuclei-03.a67c52b3.png";